import {useMutation, useQuery, useQueryClient} from "react-query";
import {
    clearCurrentCustomer,
    createUser,
    deleteUser,
    fetchByBu,
    getLogActivity,
    listUsersByIdsEc,
    setCurrentCustomer,
    updateRightUser,
    updateUser
} from "../Api/UserApi";
import {ActivityLog, User} from "../Types/User";
import toast from "react-hot-toast";
import {useIntl} from "react-intl";
import {useGetMe} from "../../../app/hooks/useGetMe";


const QUERY_KEY = 'users'

export const useGetUsers = (customerIds: number[]) => {
  return useQuery<any, Error, User[]>(
    [QUERY_KEY, customerIds],
    () => fetchByBu(customerIds),
    {enabled: customerIds.length > 0}
  );
}
export const useCurrentUser = () => {
    const customer = useGetMe();
    const { data: users } = useGetUsers(customer ? [customer.id] : []);
    return users?.[0];
};

export const useGetIdsEc = (customerIds: number[]) => {
    return useQuery<User[], Error>(
        ['usersByIdsEc', customerIds],
        () => listUsersByIdsEc(customerIds),
        {
            enabled: customerIds.length > 0,
        }
    );
};


export const useLogActivity = () => {
    return useQuery<ActivityLog[],Error>(
        ['logActivity'],
        () => getLogActivity(),
    )
}

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();


  return useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY).then(() => {
        toast.success(intl.formatMessage({id: 'CONTACT.FORM.SUCCESS'}));
      });
    },
    onError: (error) => {
      toast.error(intl.formatMessage({id: 'CONTACT.FORM.ERROR'}));
    },
  });
}


export const useUpdateUserRoles = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: updateRightUser,
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY).then(() => {
        intl.formatMessage({id: 'USER_MANAGER.UPDATE_ACCOUNT.SUCCESS'}, {})
      });
    },
    onError: (error) => {
      toast.error(intl.formatMessage({id: 'CONTACT.FORM.ERROR'}));
    },
  });
}

export const useCreateUser = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();


  return useMutation({
    mutationFn: createUser,
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY).then(() => {
        toast.success(intl.formatMessage({id: 'USER_MANAGER.CREATE_ACCOUNT.SUCCESS'}));
      });
    },
    onError: (error) => {
      toast.error(intl.formatMessage({id: 'CONTACT.FORM.ERROR'}));
    },
  });
}

export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: deleteUser,
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEY).then(() => {
        toast.success(intl.formatMessage({id: 'USER_MANAGER.DELETE_ACCOUNT.SUCCESS'}));
      });
    },
    onError: (error) => {
      toast.error(intl.formatMessage({id: 'CONTACT.FORM.ERROR'}));
    },
  });
}

// Le client courant change tout le périmètre (entités, typologie...) : on repart d'une page propre
const reloadWithNewCustomerScope = (): void => {
  sessionStorage.setItem('client_typologie', '');
  window.location.reload();
}

export const useSetCurrentCustomer = () => {
  const intl = useIntl();

  return useMutation({
    mutationFn: setCurrentCustomer,
    onSuccess: () => {
      toast.success(intl.formatMessage({id: 'ADMIN.LOGIN.FORM.SUCCESS'}));
      reloadWithNewCustomerScope();
    },
    onError: () => {
      toast.error(intl.formatMessage({id: 'HEADER.USER_MENU.LOGIN_AS_ERROR'}));
    },
  });
}

export const useClearCurrentCustomer = () => {
  const intl = useIntl();

  return useMutation({
    mutationFn: clearCurrentCustomer,
    onSuccess: () => {
      reloadWithNewCustomerScope();
    },
    onError: () => {
      toast.error(intl.formatMessage({id: 'HEADER.USER_MENU.CLEAR_CUSTOMER_ERROR'}));
    },
  });
}
